// const razorpayKey = "rzp_live_affljXkpoQaL03" /* old key */;
const razorpayKey = "rzp_live_ezysnqVcref20A"; /* JWEB-564 updated on 1/06/2020 */

var customerId = $('.ga_customerId').val();

const baseV1Header = "Basic MmI3ZTE1MTYyOGFlZDJhNmFiZjcxNTg4MDljZjRmM2M6NmJjMWJlZTIyZTQwOWY5NmU5M2Q3ZTExNzM5MzE3MmE=";

const reloadPageArray = ["/pages/cart","/pages/address","/pages/wish-list"];

const pageReloadTime = 900*1000; /* time in seconds  */

const ajaxCallTimeout = 20*1000; /* time in seconds */

// ---------- ajax call headers -----------

// basic auth header (v2)
const v2Header = {
                    "authorization": baseV1Header,
                    "content-type": "application/json",
  					"X-Platform-ID":"1"
                  }

// auth0 v3 header
if(customerId !== undefined && customerId !== ""){
  
  function getV3Header(cid){
    if(customerId === undefined || customerId === '' || customerId === null){
      customerId = cid;
    }
    
   var token = "";
    if(typeof(Storage) !== "undefined"){
        var isTokenExits = localStorage.hasOwnProperty("token");
        if(isTokenExits === true){
          token = localStorage.getItem("token");
          token = tokenValidator(token,customerId);
        }
        else{
          tokenValidator("",customerId);
          token = localStorage.getItem("token");
        }
      }
    else{
      	  token = tokenValidator("",customerId);
    }
    
  var header = {
                "authorization": "Bearer "+token,
                "content-type": "application/json",
                "X-Platform-ID":"1"
                }
  return header;
  }
}

// setInterval(function(){
//   var pageUrl = location.href;
//   var reloadPageArrayLength = reloadPageArray.length;
//   if(reloadPageArrayLength>0){
//     var i;
//     for(i=0;i<reloadPageArrayLength;i++){
//       var reloadPageName = reloadPageArray[i];
//       if(reloadPageName !== ""){
//         var pageIndex = pageUrl.indexOf(reloadPageName);
//         if(pageIndex !== -1){
//           location.reload();
//           break;
//         }
//       }
//     }
//   }
// },pageReloadTime);


// ------ website urls --------

// const webBaseUrl = window.origin;

const webBaseUrl = "https://www.jumkey.com"

const webLoginUrl = "/account/login";

const webRegUrl = "/account/register";

const webCartPageUrl = "/pages/cart";

const webAddressPageUrl = "/pages/address";

const webWishlistpageUrl = "/pages/wish-list";

const webProductPageUrl = "/products";

const ordersPageUrl = "/pages/orders";

const webAboutUsPageUrl = "/pages/about-us";

const webDownloadAppUrl = "/pages/mobile-app";

const webContactUsUrl = "/pages/contact-us";

const webWordWideShippingUrl = "/pages/international-shipping";

const webJewelleryCareTipUrl = "";

const webReturnPolicyUrl = "/pages/returns-cancellations-and-refund-policy";

const webTermsAndConditionUrl = "/pages/terms-and-conditions";


// --------- ajax call headers ends here --------

const cartBaseUrl = "https://apps.ninjaas.com";

const getCartItemsEndPoint = "/api/v3/jumkey/cart/";

const moveTowishListEndPoint = "/api/v3/jumkey/cart/";

const deleteLineTemEndPoint = "/api/v3/jumkey/cart/";

const updateQuantityEndPoint = "/api/v3/jumkey/cart/";

//  -------- JWEB-565 (new endpoints) -----
const getAddressEndPoint = "/api/v3/jumkey/customers/";

const updateAddressEndPoint = "/api/v3/jumkey/customers/";

//  -------- JWEB-565 (old endpoints) -----
// const getAddressEndPoint = "/api/v1/customers/";

// const updateAddressEndPoint = "/api/v1/customers/";

const getCheckoutEndPoint = "/api/v3/jumkey/checkout/";

const getCartItemCountEndPoint = "/api/v3/jumkey/cart/";

const codCheckEndPoint = "/api/v3/jumkey/checkout/";

const updatePaymentMethodEndPoint = "/api/v3/jumkey/checkout/";

const getCouponEndPoint = "/api/v3/jumkey/checkout/";

const applyPromoCodeEndPoint = "/api/v3/jumkey/checkout/";

const removeCouponEndPoint = "/api/v3/jumkey/checkout/";

const orderValidationEndPoint = "/api/v3/jumkey/";

const createOrderEndPoint = "/api/v3/jumkey/";

const addToCartEndPoint = "/api/v3/jumkey/cart/";

const getCartCountEndPoint = "/api/v3/jumkey/cart/"; /*{customerId}/count*/

const getWishlistEndPoint = "/api/v2/jumkey/wishlist.json?customer_id=";

const removeFromWishlistEndPoint = "/api/v2/jumkey/wishlist.json";

const collectionAndProductPageMoveToWishlistEndPoint = "/api/v2/jumkey/wishlist.json";

const v3getWishlistProductsEndPoint = "/api/v3/jumkey/wishlist/"; /*{customerId}?page=1&limit=10*/

const v3RemoveFromWishlistEndPoint = "/api/v3/jumkey/wishlist/"; /*{customerId}*/

const v3WishlistCountEndPont = "/api/v3/jumkey/wishlist/"; /*{customerId}/count*/

//  ------------------ menu navigation endpoints --------------
const getNavigationItemEndPoint = "/api/v4/menu"; /*?namespace=GLOBAL&platform=DESKTOP or MOBILE; HTTP METHOD-GET*/


//  ------------------ collection page prices and product page prices update enspoints ------------
const getProductPricesEndPoint = "/api/v4/products/variants"; /*?variantIds=""*/
const getCollectionProductPricesEndPoint = "/api/v4/collection/products/variants"; /*?variantIds=""*/
 
